import gql from 'graphql-tag'

import * as channelTypes from './types'
import { userAttrsFragment, userGroupAttrsFragment } from 'remote/users'
import { channelAcknowledgementFragment } from 'remote/activityRegistry'

export const publicChannelBaseFragment = gql`
  fragment publicChannelBaseAttrs on PublicChannel {
    id
    __typename
    name
    publicShareToken
  }
`
export const channelBaseFragment = gql`
  fragment channelBaseAttrs on Channel {
    id
    __typename
    name
    type
    createdAt
    updatedAt
    currentUserRole
    activityCount
    lastActivityBy
    lastActivityAt
    orderByField
    orderByDirection
    defaultRole
    permissions {
      read
      write
      manage
      organize
      sharePublicly
      shareToIntegrations
    }
    publiclySharedAt
    publicShareToken
    shareLink
  }
`

export const channelMembershipsFragment = gql`
  fragment channelMembershipsAttrs on Channel {
    memberships {
      __typename
      id
      nodes {
        __typename
        id
        role
        subject {
          __typename
          ... on User {
            ...userAttrs
          }
          ... on UserGroup {
            ...userGroupAttrs
          }
        }
      }
    }
  }
  ${userAttrsFragment}
  ${userGroupAttrsFragment}
`

export const channelAttrsFragment = gql`
  fragment channelAttrs on Channel {
    ...channelBaseAttrs
    activityAcknowledgement {
      ...channelAcknowledgementAttrs
    }
  }
  ${channelBaseFragment}
  ${channelAcknowledgementFragment}
`

export const publicChannelAttrsFragment = gql`
  fragment publicChannelAttrs on PublicChannel {
    ...publicChannelBaseAttrs
  }
  ${publicChannelBaseFragment}
`

export const channelAttrsForSubscriptionsFragment = gql`
  fragment channelAttrsForSubscriptions on Channel {
    ...channelBaseAttrs
  }
  ${channelBaseFragment}
`

const ChannelsAPI = {
  channelTypes,

  getPersonalChannelId(userId) {
    return `user-${userId}`
  },
}

export default ChannelsAPI

export const showChannels = gql`
  query ShowChannelsQuery($channelsIds: [ID!]!) {
    showChannels(channelsIds: $channelsIds) {
      id
      __typename
      name
      type
    }
  }
`

export const updateChannel = gql`
  mutation UpdateChannel(
    $id: ID!
    $name: String
    $type: ChannelType
    $defaultRole: ChannelMemberRole
  ) {
    updateChannel(
      id: $id
      name: $name
      type: $type
      defaultRole: $defaultRole
    ) {
      ...channelAttrs
    }
  }
  ${channelAttrsFragment}
`

export const deleteChannel = gql`
  mutation DeleteChannel($id: ID!) {
    deleteChannel(id: $id) {
      id
      __typename
    }
  }
`

export const leaveChannel = gql`
  mutation LeaveChannel($id: ID!) {
    leaveChannel(id: $id) {
      id
      __typename
    }
  }
`

export const publiclyShareChannel = gql`
  mutation PubliclyShareChannel($id: ID!) {
    publiclyShareChannel(id: $id) {
      channel {
        ...channelAttrs
      }
    }
  }
  ${channelAttrsFragment}
`

export const publiclyUnshareChannel = gql`
  mutation PubliclyUnshareChannel($id: ID!) {
    publiclyUnshareChannel(id: $id) {
      channel {
        ...channelAttrs
      }
    }
  }
  ${channelAttrsFragment}
`
